module.exports = __webpack_public_path__ + "static/media/pmgroup.adcf68a4.png";